export class Message {
    /**
	 * id kanału który wysłał wiadomość
	 */
	sender:string;

	/**
	 * id kanału który oznacza odbiorcę wiadomości
	 */
	receiver:string;

	/**
	 * Oznaczenie że wiadomość została wysłana przez server
	 */
	fromServer:boolean;

	/**
	 * Nazwa komunikatu
	 */
    name:string;
    
    params:string[];

    constructor(){
        this.params = new Array();
	}
	
}